// extracted by mini-css-extract-plugin
export default {"table":"OtherOrders_table__PI9zU"};